import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';


import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { routes } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HeadersRequestInterceptor } from './shared/services/interceptors/headers-Interceptor/headers-interceptor.interceptor';
import { SharedOrganizationService } from './shared/services/shared/organization/shared-organization.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomModalService } from './shared/services/ngBModal/custom-modal.service';
import { GlobolErrorHandlerService } from './shared/services/error/globol-error-handler.service';
import { provideServiceWorker } from '@angular/service-worker';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { provideNoopAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideNoopAnimations(),
    provideCharts(withDefaultRegisterables()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersRequestInterceptor,
      multi: true,
      deps: [SharedOrganizationService]
    },

    { provide: NgbModal, useClass: CustomModalService },
    { provide: ErrorHandler, useClass: GlobolErrorHandlerService },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),

    provideClientHydration(withEventReplay())
  ],
};
